import { CALL_API } from "admin/middlewares/api";

export const GET_BANKS_REQUEST = "GET_BANKS_REQUEST";
export const GET_BANKS_SUCCESS = "GET_BANKS_SUCCESS";
export const GET_BANKS_ERROR = "GET_BANKS_ERROR";

export function get_banks() {
  let uri = "/api/admin/get-banks";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [GET_BANKS_REQUEST, GET_BANKS_SUCCESS, GET_BANKS_ERROR],
    },
  };
}

// get representatives

export const SALESREP_GET_REQUEST = "SALESREP_GET_REQUEST";
export const SALESREP_GET_SUCCESS = "SALESREP_GET_SUCCESS";
export const SALESREP_GET_ERROR = "SALESREP_GET_ERROR";

export function get_salesrepresentatives() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/sales-representatives",
      authenticatedRequest: true,
      types: [SALESREP_GET_REQUEST, SALESREP_GET_SUCCESS, SALESREP_GET_ERROR],
    },
  };
}

export const GDPR_REMOVE_REQUEST = "GDPR_REMOVE_REQUEST";
export const GDPR_REMOVE_SUCCESS = "GDPR_REMOVE_SUCCESS";
export const GDPR_REMOVE_ERROR = "GDPR_REMOVE_ERROR";

export function gdpr_remove(personId) {
  const uri = "/api/admin/savelend/gdpr-remove-person";

  return {
    [CALL_API]: {
      method: "POST",
      data: { Id: personId },
      endpoint: uri,
      authenticatedRequest: true,
      types: [GDPR_REMOVE_REQUEST, GDPR_REMOVE_SUCCESS, GDPR_REMOVE_ERROR],
    },
  };
}
export const MANUALLY_MARK_AS_IDENTIFIED_REQUEST =
  "MANUALLY_MARK_AS_IDENTIFIED_REQUEST";
export const MANUALLY_MARK_AS_IDENTIFIED_SUCCESS =
  "MANUALLY_MARK_AS_IDENTIFIED_SUCCESS";
export const MANUALLY_MARK_AS_IDENTIFIED_ERROR =
  "MANUALLY_MARK_AS_IDENTIFIED_ERROR";

export function manuallyMarkAsIdentified(personId) {
  const uri =
    "/api/admin/savelend/manually-mark-as-identified?personId=" + personId;

  return {
    [CALL_API]: {
      method: "POST",
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        MANUALLY_MARK_AS_IDENTIFIED_REQUEST,
        MANUALLY_MARK_AS_IDENTIFIED_SUCCESS,
        MANUALLY_MARK_AS_IDENTIFIED_ERROR,
      ],
    },
  };
}

export const GDPR_DEACTIVATE_REQUEST = "GDPR_DEACTIVATE_REQUEST";
export const GDPR_DEACTIVATE_SUCCESS = "GDPR_DEACTIVATE_SUCCESS";
export const GDPR_DEACTIVATE_ERROR = "GDPR_DEACTIVATE_ERROR";

export function gdpr_deactivate(id) {
  const uri = "/api/admin/savelend/gdpr-deactivate-investor";

  return {
    [CALL_API]: {
      method: "POST",
      data: { Id: id },
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        GDPR_DEACTIVATE_REQUEST,
        GDPR_DEACTIVATE_SUCCESS,
        GDPR_DEACTIVATE_ERROR,
      ],
    },
  };
}

export const GDPR_REMOVE_BORROWER_REQUEST = "GDPR_REMOVE_BORROWER_REQUEST";
export const GDPR_REMOVE_BORROWER_SUCCESS = "GDPR_REMOVE_BORROWER_SUCCESS";
export const GDPR_REMOVE_BORROWER_ERROR = "GDPR_REMOVE_BORROWER_ERROR";

export function gdpr_remove_borrower(Ssn) {
  let uri = "/api/admin/loanstep/gdpr-remove";

  return {
    [CALL_API]: {
      method: "POST",
      data: { Ssn },
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        GDPR_REMOVE_BORROWER_REQUEST,
        GDPR_REMOVE_BORROWER_SUCCESS,
        GDPR_REMOVE_BORROWER_ERROR,
      ],
    },
  };
}
